module.exports = __webpack_public_path__ + "img/home_phone_banner3.5fb6b8ce.png";